import { ElementRef, Injectable, QueryList, ViewChildren } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DynamicComponentsService {

  private elementMap: { [key: string]: ElementRef<HTMLDivElement> } = {};

  // Register an element
  registerElement(key: string, element: ElementRef<HTMLDivElement>): void {
    this.elementMap[key] = element;
  }

  // Get an element by key
  getElement(key: string): ElementRef<HTMLDivElement> | undefined {
    return this.elementMap[key];
  }

  // Scroll to an element by key
  scrollToElement(key: string): void {
    const element = this.getElement(key);
    if (element) {
      element.nativeElement.scrollIntoView({ behavior: 'smooth' });
    } else {
      console.warn(`Element with key "${key}" not found.`);
    }
  }
}
